import { combineReducers } from 'redux'
import merge from 'lodash/merge'

import { RECEIVE_IDENTITY_PROVIDERS } from '../actions/idp-actions.js'

const list = (state = [], action) => {
  switch(action.type) {
    case RECEIVE_IDENTITY_PROVIDERS: return merge([], action.identityProviders)
    default: return state
  }
}

export default combineReducers( {
  list
})
